import * as React from "react";
import { connect, ConnectedProps } from "react-redux";

import { UserProfile } from "./UserProfile";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { PROFILE_ROUTE } from "components/router/Routes";
import { StoreState } from "store";

const mapState = (state: StoreState) => ({
    user: state.userReducer.user,
});
const connector = connect(mapState);
type Props = ConnectedProps<typeof connector>;

const UserProfilePage = (props: Props): JSX.Element => {
    return <ApplicationLayout viewTitle={""} view={<UserProfile user={props.user} />} mainRoute={PROFILE_ROUTE} />;
};

export default connector(UserProfilePage);
